module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="suggestions__intro detail-hidden">\n    Before we get to review, we found ' +
__e( count ) +
' job';
 if (count > 1 ) { ;
__p += 's';
 } ;
__p += '\n    we think you\'d also be a good candidate for.\n    <strong>Do you want to add any of these to your application?</strong>\n</div>\n\n<div class="suggestions__container detail-hidden">\n    <div class="suggestions__card"></div>\n</div>\n\n<div class="suggestions__buttons" style="display: none">\n    <div class="suggestions__buttons-inner">\n        <span class="suggestions__pass tooltip" data-tooltip="Pass">\n            ' +
((__t = ( $.svgIcon('pass') )) == null ? '' : __t) +
'\n        </span>\n        <span class="suggestions__approve tooltip" data-tooltip="Add">\n            ' +
((__t = ( $.svgIcon('approve') )) == null ? '' : __t) +
'\n        </span>\n    </div>\n    <div class="skip-button-holder">\n        <a class="skip-suggestions" style="display: none">\n            Skip\n        </a>\n    </div>\n</div>\n\n<div id="auto-match-modal" class="modal-small" style="display: none">\n    <h2>Why am I pre-qualified to interview?</h2>\n    <p>\n        Based on what we know about your skills and experience,\n        this company wants you to schedule an interview right away!\n    </p>\n    <a href="#" rel="modal:close" class="btn btn-primary btn-large">Got it</a>\n</div>\n';

}
return __p
}